export type UserOrganizationInfo = {
  organizationId: number;
  fullName: string;
  shortName: string;
  licenseExpirationDate?: string | null;
  maximumTransactionCount: number;
}

export type UserProfile = {
  userId: string;
  userName: string;
  roles: string[];
  permissions: string[];
  organizations: UserOrganizationInfo[];
  defaultOrganization: number;
  defaultOrganizationInfo: UserOrganizationInfo;
};

export type UserPreference = {
  userId: string;
  preferenceKey: string;
  preferenceType: "Object";
  preferenceValue: string;
  prefenceObject: string;
  createdBy: string;
  lastUpdatedBy: string;
  createdTime: Date;
  lastUpdatedTime: Date;
}

export const UserPreferenceKeyCurrentWorkingOrganization = "CurrentWorkingOrganization";

export type UserPreferenceKeyRequest = {
  key: string;
}